export default __webpack_public_path__ + "static/media/crumble_thumb.87525c79.jpg";